'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var statefulMap = ['methods', 'mapState', 'connectState', 'defaultState', 'contextTypes'];

exports.default = function () {
  return function (Component) {
    if ((0, _utils.includesOne)(Object.keys(Component), statefulMap)) {
      var AbyssComponent = function (_React$Component) {
        _inherits(AbyssComponent, _React$Component);

        function AbyssComponent(props) {
          _classCallCheck(this, AbyssComponent);

          var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

          _this.getMergedProps = function () {
            return Object.assign({}, _this.props, _this.state, _this.componentRefs, _this.context, _this.methods, _this.privateMethods);
          };

          _this.methods = {};
          var methods = Object.assign({}, Component['methods']);

          Object.keys(methods).forEach(function (key) {
            switch (key) {
              case 'componentWillMount':
              case 'componentDidMount':
              case 'componentWillUnmount':
                {
                  _this[key] = function () {
                    return methods[key](_this.getMergedProps());
                  };
                  break;
                }
              case 'componentWillReceiveProps':
              case 'shouldComponentUpdate':
              case 'componentWillUpdate':
              case 'componentDidUpdate':
                {
                  _this[key] = function (newProps, newState) {
                    var merged = _this.getMergedProps();
                    return methods[key](merged, Object.assign({}, merged, newProps, newState));
                  };
                  break;
                }
              default:
                {
                  _this.methods[key] = function () {
                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                      args[_key] = arguments[_key];
                    }

                    return methods[key].apply(null, [_this.getMergedProps()].concat(args));
                  };
                  break;
                }
            }
          });

          _this.componentRefs = {};
          _this.privateMethods = {
            setRef: function setRef(ref) {
              return Object.assign(_this.componentRefs, ref);
            },
            forceUpdate: function forceUpdate(callback) {
              return _this.forceUpdate(callback);
            }
          };

          if (Component['defaultState']) {
            _this.state = (0, _cloneDeep2.default)(typeof Component['defaultState'] === 'function' ? Component['defaultState'](_this.props) : Component['defaultState']);

            _this.privateMethods.setState = function (state, callback) {
              return _this.setState(state, callback);
            };
          } else {
            _this.privateMethods.setState = function () {
              throw new Error('abyss-react: Please attach a defaultState to a Component before using setState.');
            };
          }
          return _this;
        }

        AbyssComponent.prototype.render = function render() {
          var mergedProps = Object.assign({}, this.props, this.state, this.componentRefs, this.context, this.methods);

          delete mergedProps.dispatch;
          return _react2.default.createElement(Component, mergedProps);
        };

        return AbyssComponent;
      }(_react2.default.Component);

      var displayName = Component.displayName || Component.name || 'Component';
      AbyssComponent.displayName = 'Abyss(' + displayName + ')';
      AbyssComponent.WrappedComponent = AbyssComponent;

      return Object.assign(AbyssComponent, Component);
    }

    return Component;
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/abyss-react/lib/applyStateful.js
// module id = 529
// module chunks = 0